import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('IconButtonGhostMini', slot);
}

// generateUtilityClasses가 이미 타입을 제공하므로 별도 인터페이스 불필요
export const iconButtonGhostMiniClasses = generateUtilityClasses('IconButtonGhostMini', [
  'root',
  'icon',
]);

// ✅ theme 등록 완전 제거 (styleOverrides, defaultProps, variants가 모두 컴포넌트로 이전됨)
// ✅ module augmentation 완전 제거
